/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridColumnOptionsBase } from "./GridColumnOptionsBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridColumnOptionsSectionBase = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridColumnOptionsSectionBase, _super);
    function GridColumnOptionsSectionBase() {
        var _this = _super.call(this) || this;
        _this.bh();
        _this.be();
        return _this;
    }
    GridColumnOptionsSectionBase.prototype.ba = function (a, b, c) {
        _super.prototype.ba.call(this, a, b, c);
        switch (a) {
            case "ActualLabelTextStyle":
            case "ActualBaseTheme":
            case "ActualButtonDensity":
            case "ActualButtonTextStyle":
            case "ActualDensity":
                this.e.m();
                break;
        }
    };
    GridColumnOptionsSectionBase.$t = markType(GridColumnOptionsSectionBase, 'GridColumnOptionsSectionBase', GridColumnOptionsBase.$);
    return GridColumnOptionsSectionBase;
}(GridColumnOptionsBase));
export { GridColumnOptionsSectionBase };
//# sourceMappingURL=GridColumnOptionsSectionBase.js.map
